import { Route as VueRoute } from 'vue-router/types/router'
import { Route } from '~/config/routes.types'
import ROUTES from '~/config/routes'

export const getRouteDefinition = (route: VueRoute): Route | null => {
  const routes = ROUTES as any
  const routesName = route.name as any

  return routes[routesName] || null
}
